import React, { useEffect, useState } from 'react'
import Loading from './Common/ui/Loading'
import { useCommonStore } from './Common/store/CommonStore'

function RouterValidator ({ children, associatedFeatures }) {
    const [ isValid, setIsValid ] = useState(false)
    const authStorage = JSON.parse(localStorage.getItem('auth-storage'))
    const data = useCommonStore(stat => stat.getAllFeaturesData)
    useEffect(() => {
        (async () => {
            setIsValid(false)
            if (data?.find((ele) => associatedFeatures?.includes(ele.featureName)) && authStorage?.accessToken !== null) {
                setIsValid(true)
            } else {
                setIsValid(false)
            }
        })()
    }, [ children, data ])
    if (isValid) {
        return (
            children
        )
    } else {
        return <Loading isLoading={true} />
    }
}

export default RouterValidator
